/* eslint-disable react/require-default-props */
import React from 'react';
import {View} from 'react-native';
import {get, isNil} from 'lodash';

import ReportDefaultLoading from '/component/partial/report/ReportDefaultLoading';
import {getDefaultNewCoachesKey} from '/util/filter.util';

import {styles} from './Footer.style';
import {getLoadingItemsCount} from './Footer.util';
interface FooterProps {
  loadingData: {
    total?: number;
  } | null;
  reportData: any;
  reportIsLoading: boolean;
  loadingComponent: React.ComponentType<{total: number}> | null;
  reportMeta: {
    page?: {
      total?: number;
    };
  } | null;
  filtersData?: Record<string, any> | null;
  reportParams?: any;
  reportName?: string;
}

export const Footer: React.FC<FooterProps> = ({
  loadingData = null,
  reportData = null,
  reportIsLoading = true,
  loadingComponent: LoadingComponent = null,
  reportMeta = null,
  filtersData = null,
  reportParams = null,
  reportName = '',
}) => {
  let total;

  if (reportName === 'MY_TEAMS') {
    const {sortBy = '', sortOrder = ''} = reportParams?.[0] || {};

    const isFiltersDefault = (() => {
      if (!filtersData) return true;

      return (
        (!filtersData.rank || filtersData.rank.length === 0) &&
        (!filtersData.fibc || filtersData.fibc === 'Any') &&
        (!filtersData.period ||
          filtersData.period === getDefaultNewCoachesKey) &&
        !filtersData.frontline &&
        !filtersData.closeToNextRank &&
        !filtersData.cabEarned &&
        !filtersData.aabEarned &&
        filtersData.fqvMin == null &&
        filtersData.fqvMax == null &&
        filtersData.newClientsAbove == null &&
        filtersData.newClientsBelow == null &&
        filtersData.qualifiedClientsAbove == null &&
        filtersData.qualifiedClientsBelow == null &&
        filtersData.newCoachesAbove == null &&
        filtersData.newCoachesBelow == null
      );
    })();

    const isDefaultView =
      (sortBy === 'rank' || (sortBy === 'default' && sortOrder === 'DESC')) &&
      isFiltersDefault;

    const rawTotal = get(
      loadingData,
      'total',
      get(reportMeta, 'page.total', ''),
    );
    const rawFilterCount = get(
      loadingData,
      'filtercount',
      get(reportMeta, 'page.filtercount', ''),
    );

    total = isDefaultView ? rawTotal : rawFilterCount;
  } else {
    total = get(loadingData, 'total', get(reportMeta, 'page.total', ''));
  }

  const reportDataLength = get(reportData, 'length', 0);
  if (!reportIsLoading || reportDataLength >= total) {
    return <View style={styles.bottomSpace} />;
  }

  const itemsCount = getLoadingItemsCount({total, reportDataLength});

  return !isNil(LoadingComponent) ? (
    <LoadingComponent total={itemsCount} />
  ) : (
    <ReportDefaultLoading
      style={{
        row: styles.row,
        sponsoredDate: styles.sponsoredDate,
      }}
      total={itemsCount}
    />
  );
};
